import { initMonitoring, setMonitoringTrackingConsent } from "@/core/monitoring";

import type { InstrumentationSubscriber } from "@/core/instrumentation/instrumentation.types";

/**
 * Datadog RUM + Logs on the bus. Reuses the init seam from `@/core/monitoring`
 * (the barrel is deliberately React-free — it is what
 * `instrumentation-client.ts` imports) rather than duplicating its config.
 *
 * `necessary`-scoped: collection is NOT consent-gated (T-3337, reaffirmed at
 * the flip on T-3800). Both SDKs start at page load from the client
 * instrumentation hook, for every visitor, and this sink never tears them
 * down — a revoke is not a stop. `activate` re-runs the idempotent init as
 * defense in depth for any page where the hook did not run first.
 *
 * What consent DOES drive is the `analytics_consent` facet, stamped from
 * `consent.changed` so that opt-in rate stays measurable and analyses that
 * require consent can filter to the consented population. Only a resolved
 * status is stamped: an unresolved visitor is "never asked", which must stay
 * distinguishable from a real decline, so it carries no facet at all.
 */
export const createDatadogSink = (): InstrumentationSubscriber => ({
  name: "datadog",
  requiredScope: "necessary",
  activate: () => {
    initMonitoring();
  },
  handle: (event) => {
    if (event.topic !== "consent.changed" || event.payload.status !== "resolved") {
      return;
    }

    setMonitoringTrackingConsent(event.payload.decision.analytics);
  },
});
